import { render } from "./Breadcrumb.vue?vue&type=template&id=3887aedd&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=3887aedd&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3887aedd"]])

export default __exports__